interface Props {
  filename: string;
}

export const stripFileExtension = ({ filename }: Props): string =>
  filename.replace(/\.\w+$/, '');
